export default __webpack_public_path__ + "static/7-4--784086ae76aa093992ea5abefffe394a.png";